import { doc } from 'firebase/firestore';
import { getDocFromServer } from './firestoreRead';
import { db, auth } from '../firebase/firebaseConfig';
import {recuperarActividad} from './actividadService';
import { operarReserva, nuevaSolicitudReserva } from './reservasPrivadas';

export async function cargarEntregaReserva(reserva) {
  return recuperarActividad({tipo:'reservas',id:reserva.id});
}

// Toda mutación se autoriza y serializa en servidor; no hay batch comercial cliente.
export async function persistirReserva({base,reservaExistenteId=null,paqueteId=null,carrito={},solicitudId=nuevaSolicitudReserva(),importeEsperadoCentavos},database=db,uid=auth.currentUser?.uid) {
  if(!uid)throw new Error('Sesión no verificada.');
  const resultado=await operarReserva({accion:reservaExistenteId?'prepagar':'crear',eventoId:base.eventoId,base,
    ...(reservaExistenteId?{reservaId:reservaExistenteId}:{}),paqueteId,carrito,solicitudId,
    ...(importeEsperadoCentavos!==undefined?{importeEsperadoCentavos}:{})});
  if(paqueteId)return cargarEntregaReserva({id:resultado.reservaId},database);
  const s=await getDocFromServer(doc(database,'reservas',resultado.reservaId));
  if(!s.exists())throw new Error('No se pudo recuperar la reserva confirmada.');
  return {reserva:{...s.data(),id:s.id},items:[]};
}
